import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

export default ({ src, alt, className = 'mt-8 w-full' }) => {
  const { allImageSharp } = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
              originalName
            }
          }
        }
      }
    }
  `)

  const image = allImageSharp.edges.find(
    (edge) => edge.node.fluid.originalName === src
  )

  if (!image) {
    return null
  }

  return <Img className={className} fluid={image.node.fluid} alt={alt} />
}
